export default layout => {
  const reduceMappedRequired = (required, composition) => composition.reduce((required, field) => {
    var _field$composition;
    if ((_field$composition = field.composition) !== null && _field$composition !== void 0 && _field$composition.length) {
      const newRequired = field.isRequired ? [...required, field.id] : required;
      return reduceMappedRequired(newRequired, field.composition);
    } else if (field.mappedFields && field.isRequired) {
      return [...required, field.id];
    }
    return required;
  }, required);
  return reduceMappedRequired([], layout.composition);
};